import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AddAttendeesResultModal} from './add-attendees.result.modal';
import {
    clearResult,
    selectImportAttendeesShown,
    selectImportAttendeesTask,
    selectImportAttendeesUuid,
} from './add-attendees.slice';


export const AddAttendeesResult = () => (
    <BulkActionResult
        actionIdSelector={selectImportAttendeesUuid}
        actionTaskSelector={selectImportAttendeesTask}
        actionShownSelector={selectImportAttendeesShown}
        clearResult={clearResult}>
        {({id, onClose}) => <AddAttendeesResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
